import React, { useState, useEffect, useReducer } from "react";
import Close from "../../utils/icons/Close";
import { closePopUp, showPopUp } from "../../utils/Overlay";
import ContentPreview from "../ContentPreview";
import ContentSelector from "../editor/ContentSelector";
import OpSimple from "../editor/operations/OpSimple";
import { Link } from "react-router-dom";
import { trackEvent } from "../../helpers";

export default function PickContent({
  campaign,
  onSelect,
}: {
  campaign: Post;
  onSelect: Function;
}) {
  const [selectedContent, setContent] = useReducer(contentReducer, []);
  const [pickingContent, setPickingContentFlag] = useState(false);
  const fulfilled = selectedContent.length > 0;
  const contentToSelectFrom = ((campaign.content as Content[]) || []).filter(
    (c) => {
      return !selectedContent.find((sc) => sc.id === c.id);
    }
  );

  useEffect(() => {
    onSelect(selectedContent);
  }, [selectedContent.length]);

  useEffect(() => {
    if (pickingContent) {
      showSelector();
    }
  }, [contentToSelectFrom.length]);

  function showSelector() {
    setPickingContentFlag(true);
    showPopUp(
      <div className="rel">
        <ContentSelector
          key={`cs_${(campaign.content || []).length}`}
          post={campaign}
          Form={OpSimple}
          content={contentToSelectFrom}
          labelButton="Select"
          types={[]}
          filter={ContentSelector.filterAllowAll}
          validator={ContentSelector.atLeastOne}
          onSelected={async (selection) => {
            setContent({ type: "add", data: selection.content });
            setPickingContentFlag(false);
            closePopUp();
          }}
          hideResultsPreview
        />
        <button
          className="reset as-link abs"
          style={{ top: "-29px", right: "-27px" }}
          onClick={() => {
            setPickingContentFlag(false);
            closePopUp();
          }}
        >
          <Close />
        </button>
      </div>,
      {
        width: "620px",
      }
    );
  }

  return (
    <div className={"scheduler-phase " + (fulfilled ? "fulfilled" : "")}>
      <div>
        {fulfilled && (
          <ul>
            {selectedContent.map((content: Content) => {
              return (
                <ContentPreview content={content} key={content.id}>
                  <div className="content-cta-container">
                    <button
                      className={"reset as-link ib with-icon mb03 fz12 tac"}
                      onClick={() =>
                        setContent({ type: "remove", data: [content] })
                      }
                    >
                      <small className="fz08">✖</small>
                    </button>
                  </div>
                </ContentPreview>
              );
            })}
          </ul>
        )}
        {contentToSelectFrom.length > 0 ? (
          <div className={selectedContent.length === 0 ? "tac" : ""}>
            <button
              className={fulfilled ? "small mt1" : "primary"}
              onClick={() => {
                trackEvent("schedule-new-post");
                showSelector();
              }}
            >
              {fulfilled ? "Select more items" : "Schedule a new post"}
            </button>
          </div>
        ) : (
          <div className="tac">
            In order to publish a post you first have to{" "}
            <Link to={`/campaigns/edit/${campaign.id}/content`}>
              add content
            </Link>
            .
          </div>
        )}
      </div>
    </div>
  );
}

function contentReducer(state, action) {
  const content = action.data as Content[];
  let soFar = [...state];
  if (action.type === "add") {
    for (let i = 0; i < content.length; i++) {
      if (!soFar.find((c) => c.id === content[i].id)) {
        soFar.push(content[i]);
      }
    }
  } else {
    for (let i = 0; i < content.length; i++) {
      soFar = soFar.filter((c) => c.id !== content[i].id);
    }
  }
  return soFar;
}
